import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
// import $ from 'jquery's
import Storage from './assets/js/storage.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Base64 } from 'js-base64'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueTouch from 'vue-touch'
import 'default-passive-events'
import md5 from './assets/js/md5.min'
import VConsole from './assets/js/vconsole.min'
import { encrypt, decrypt } from '../admin/assets/js/encryp'
import './common/css/common.css'
import '../assets/css/common.css'
import WXConfig from '../index/assets/js/wxShare'

let url = window.location.href
WXConfig.wxshare(
  url,
  '生涯规划咨询师',
  'https://resource.netclass.cn/banner.jpg',
  '生涯规划咨询师是个人学习进步和职业生涯发展的重要导师，可以为学生提供全面、专业的生涯规划服务。生涯规划咨询师项目的目标是帮助学生了解自己的兴趣爱好、优点和潜力，进一步明确自己的职业目标，制定科学的职业规划方案，实现自我发展和职业成长的目标。'
)
Vue.use(ElementUI, axios)
Vue.use(preview)
Vue.use(VueTouch, { name: 'v-touch' })
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$qiniuUrl = 'http://resource.wangpeishi.org.cn/'
Vue.prototype.$price = '2480元'
Vue.prototype.Storage = Storage
Vue.prototype.$md5 = md5
Vue.prototype.$VConsole = VConsole
Vue.prototype.$encrypt = encrypt
Vue.prototype.$decrypt = decrypt
Vue.prototype.$Base64 = Base64
axios.interceptors.request.use(
  config => {
    let token = Storage.getStorage('token')
    if (config.url.indexOf('admin') != -1) {
      token = Storage.getStorage('adminToken')
    }
    // if (window.location.href.indexOf('/ks') != -1) {
    //   token = Storage.getStorage('ksToken')
    // }
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      if (error.response.status == 401) {
        localStorage.clear()
        setTimeout(function() {
          location.href = '/#/login'
        }, 2000)
      }
    }
    // return Promise.reject(error.response.data)
  }
)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.afterEach(() => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
})

new Vue({
  router,
  store,
  render: h => h(App),
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'))
  // }
}).$mount('#app')
